import RepositoryFactory from '@/shared/services/repositories/repository.factory';

export default class BaseService {
  #serviceName;
  #repositoryType;

  repository;

  constructor(serviceName, repositoryType = 'restful') {
    if (!serviceName) {
      throw new Error('Service name is required');
    }

    this.#serviceName = serviceName;
    this.#repositoryType = repositoryType;
    this.repository = RepositoryFactory.getRepository(this.#serviceName, this.#repositoryType);
  }

  get serviceName() {
    return this.#serviceName;
  }

  get version() {
    return '1.0';
  }

  // Helper method for handling API responses
  handleResponse(response) {
    if (response?.payload) {
      return response.payload;
    }
    return response;
  }

  // Helper method for error handling
  handleError(error, context = '') {
    const errorMessage = error?.message || 'Unknown error occurred';
    console.error(`[${this.#serviceName}Service] ${context}:`, errorMessage);

    // You can add more sophisticated error handling here
    // like sending to error tracking service

    throw error;
  }
}
